import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  User, CreditCard, Heart, Briefcase, Star,
  Bell, Shield, HelpCircle, Settings, LogOut,
  ChevronRight, Edit, MapPin, Calendar,ArrowLeft,Crown,RefreshCw,
  
} from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import '../../../../assets/css/screens/customer/dashboard/profile/profile.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';

/* ── Switch Modal ── */
const SwitchModal = ({ onClose, onSwitchNow }) => (
  <div className="wp-modal-overlay" onClick={onClose}>
    <div className="wp-switch-modal" onClick={e => e.stopPropagation()}>
      <div className="wp-switch-modal__icon"><RefreshCw size={28} /></div>
      <h3 className="wp-switch-modal__title">Switch to Customer</h3>
      <p className="wp-switch-modal__desc">
        Login with your customer account to book services. You can switch back anytime.
      </p>
      <div className="wp-switch-modal__actions">
        <button className="wp-modal__cancel" onClick={onClose}>Cancel</button>
        <button className="wp-switch-modal__confirm" onClick={onSwitchNow}>
          <RefreshCw size={15} /> Switch Now
        </button>
      </div>
    </div>
  </div>
);

const Profile = () => {
  const navigate = useNavigate();
  const {baseUrl, baseUrlForFile, authToken } = useContext(AppContext);
  const [switchModal, setSwitchModal] = useState(false);

const [user, setUser] = useState({
  name: '',
  email: '',
  phone: '',
  avatar: '',
  stats: {
    orders: 0,
    favorites: 0,
    reviews: 0
  }
});
// fetch profile data 
useEffect(() => {
  viewProfile();
}, []);

const viewProfile = () => {
  const token = localStorage.getItem("authToken")?.trim();

  axios.get(`${baseUrl}/customer/viewProfile`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((res) => {
    const data = res.data.customer;
    console.log("PROFILE API RESPONSE:", res.data);

setUser({
  name: data.fullName || '',
  email: data.email || '',
  phone: data.phoneNumber || '',

avatar: data.ProfileImage
    ? `${baseUrlForFile}/${data.ProfileImage}`
    : `https://ui-avatars.com/api/?name=${encodeURIComponent(data.fullName || "User")}`,

  stats: {
    orders: data.ordersCount || 0,
    favorites: data.favoritesCount || 0,
    reviews: data.reviewsCount || 0
  }
});
  })
  .catch((err) => {
    console.log("Profile Error:", err.response?.data || err.message);
  });
};
// delete account
const handleDeleteProfile = () => {

  Swal.fire({
    title: 'Delete Account?',
    html: `
      <p style="line-height:1.6;">
        This action will permanently delete your account.<br/>
        <span style="color:red;font-weight:600;">
          This cannot be undone.
        </span>
      </p>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Yes, Delete'
  })

  .then(async (result) => {

    // sirf yes par delete hoga
    if (result.isConfirmed) {

      try {

        const res = await axios.delete(
          `${baseUrl}/customer/deleteAccount`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`
            }
          }
        );

        console.log(res.data);

        if (res.data.success) {

          localStorage.clear();

          await Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Your account has been deleted successfully',
            timer: 1800,
            showConfirmButton: false
          });

          navigate("/");

        } else {

          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: res.data.message || 'Delete failed'
          });

        }

      } catch (err) {

        console.log("DELETE ERROR:", err.response?.data || err.message);

        Swal.fire({
          icon: 'error',
          title: 'Server Error',
          text: 'Something went wrong'
        });

      }

    }

  });

};
  const menuItems = [
    {
      id: 'edit-profile',
      icon: <User size={22} />,
      title: 'Edit Profile',
      subtitle: 'Update your personal information',
      color: '#0491e1',
      route: '/profile-settings'
    },
    {
  id: 'subscription',
  icon: <Crown size={22} />,
  title: 'Subscription',
  subtitle: 'Manage your subscription plans',
  color: '#f59e0b',
  route: '/worker-subscription-history'
},
    // {
    //   id: 'Hire-professional',
    //   icon: <CreditCard size={22} />,
    //   title: 'All professionals',
    //   subtitle: 'Manage your payment options',
    //   color: '#10b981',
    //   route: '/hire-professional'
    // },
   
    // {
    //   id: 'favorites',
    //   icon: <Heart size={22} />,
    //   title: 'Favorites',
    //   subtitle: 'Your saved services',
    //   color: '#ef4444',
    //   route: '/favorites'
    // },
   {
  id: 'My Jobs',
  icon: <Briefcase size={22} />,
  title: 'My Jobs',
  subtitle: 'Track your jobs',
  color: '#3b82f6', // Blue
  route: '/my-jobs'
},
// {
//   id: 'Bookings',
//   icon: <Calendar size={22} />,
//   title: 'My Bookings',
//   subtitle: 'Track your bookings',
//   color: '#10b981', // Green
//   route: '/mybookings'
// },
    {
      id: 'reviews',
      icon: <Star size={22} />,
      title: 'My Reviews',
      subtitle: 'Your ratings and feedback',
      color: '#f59e0b',
      route: '/customer-reviews'
    },
    {
      id: 'notifications',
      icon: <Bell size={22} />,
      title: 'Notifications',
      subtitle: 'Manage notification preferences',
      color: '#06b6d4',
      route: '/customer-notifications'
    },
    // {
    //   id: 'security',
    //   icon: <Shield size={22} />,
    //   title: 'Privacy & Security',
    //   subtitle: 'Password and security settings',
    //   color: '#84cc16',
    //   route: '/privacy-security'
    // },
    {
      id: 'help',
      icon: <HelpCircle size={22} />,
      title: 'Help & Support',
      subtitle: 'Get assistance',
      color: '#6366f1',
      route: '/customer-support'
    },
    {
      id: 'settings',
      icon: <Settings size={22} />,
      title: 'Settings',
      subtitle: 'App preferences',
      color: '#64748b',
      route: '/customer-settings'
    }
  ];

  const handleMenuClick = (route) => {
    navigate(route);
  };

 
// logout
const handleLogout = () => {

  Swal.fire({
    title: 'Log Out?',
    text: 'Are you sure you want to log out?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Yes, Logout'
  })

  .then(async (result) => {

    // sirf yes par chalega
    if (result.isConfirmed) {

      try {

        const res = await axios.post(
          `${baseUrl}/customer/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`
            }
          }
        );

        console.log(res.data);

        if (res.data.success) {

          localStorage.clear();

          await Swal.fire({
            icon: 'success',
            title: 'Logged Out',
            text: 'You have been logged out successfully',
            timer: 1500,
            showConfirmButton: false
          });

          navigate("/");

        }

      } catch (err) {

        console.log("LOGOUT ERROR:", err.response?.data || err.message);

        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: 'Logout failed'
        // });

      }

    }

  });

};
  
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
    <AppNavbar />
    <div className="profile-page">
      
      
      {/* ════ HEADER ════ */}
      <div className="inbox-header">
        <button className="inbox-back-btn" onClick={handleBack}>
          <ArrowLeft size={24} />
        </button>
        <h2 className="inbox-title">Profile</h2>
      </div>




      {/* ════ DESKTOP: CARDS GRID ════ */}
      <div className="profile-desktop">
        
        {/* User Info Card */}
        <div className="profile-card profile-user-card">
          <div className="profile-avatar-wrapper">
{user.avatar && (
 <img 
 src={user.avatar} 
 alt={user.name}
 className="profile-avatar"
 onError={(e)=>{
   e.target.src =
   `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}`
 }}
/>
)}          <button className="profile-edit-avatar" onClick={() => navigate("/profile-settings")}>
  <Edit size={16} />
</button>
          </div>
          
          <h5 className="profile-user-name">{user.name}</h5>
          <p className="profile-user-email">{user.email}</p>
          <p className="profile-user-phone">{user.phone}</p>
          
          <div className="profile-stats">
            <div className="profile-stat">
              <span className="profile-stat-value">{user.stats.orders}</span>
              <span className="profile-stat-label">Orders</span>
            </div>
            <div className="profile-stat">
              <span className="profile-stat-value">{user.stats.favorites}</span>
              <span className="profile-stat-label">Favorites</span>
            </div>
            <div className="profile-stat">
              <span className="profile-stat-value">{user.stats.reviews}</span>
              <span className="profile-stat-label">Reviews</span>
            </div>
          </div>
        </div>

        {/* Menu Cards Grid */}
        <div className="profile-menu-grid">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="profile-menu-card"
              onClick={() => handleMenuClick(item.route)}
            >
              <div className="profile-menu-icon" style={{ backgroundColor: `${item.color}15` }}>
                <span style={{ color: item.color }}>
                  {item.icon}
                </span>
              </div>
              <h5 className="profile-menu-title">{item.title}</h5>
              <p className="profile-menu-subtitle">{item.subtitle}</p>
              <ChevronRight className="profile-menu-arrow" />
            </div>
          ))}
          
          {/* Logout Card */}
          <div className="profile-menu-card profile-logout-card" onClick={handleLogout}>
            <div className="profile-menu-icon" style={{ backgroundColor: '#fee2e2' }}>
              <span style={{ color: '#ef4444' }}>
                <LogOut size={22} />
              </span>
            </div>
            <h5 className="profile-menu-title">Log Out</h5>
            <p className="profile-menu-subtitle">Sign out of your account</p>
            <ChevronRight className="profile-menu-arrow" />
          </div>
         <div className="profile-menu-card profile-logout-card" onClick={handleDeleteProfile}>
  <div className="profile-menu-icon" style={{ backgroundColor: '#fee2e2' }}>
    <span style={{ color: '#ef4444' }}>
      <LogOut size={22} />
    </span>
  </div>

  <h5 className="profile-menu-title">Delete Account</h5>
  <p className="profile-menu-subtitle">Permanently remove your profile</p>

  <ChevronRight className="profile-menu-arrow" />
</div>
        </div>
      </div>

      {/* ════ MOBILE: LIST VIEW ════ */}
      <div className="profile-mobile">
        
        {/* Mobile User Card */}
        <div className="profile-mobile-user">
    
 {user.avatar && (
 <img 
 src={user.avatar} 
 alt={user.name}
 className="profile-avatar"
 onError={(e)=>{
   e.target.src =
   `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}`
 }}
/>
)}

          <div className="profile-mobile-info">
            <h5 className="profile-mobile-name">{user.name}</h5>
            <p className="profile-mobile-email">{user.email}</p>
          </div>
          <button className="profile-mobile-edit">
            <Edit size={18} />
          </button>
        </div>

        {/* Mobile Stats */}
        <div className="profile-mobile-stats">
          <div className="profile-mobile-stat">
            <span className="profile-mobile-stat-value">{user.stats.orders}</span>
            <span className="profile-mobile-stat-label">Orders</span>
          </div>
          <div className="profile-mobile-stat">
            <span className="profile-mobile-stat-value">{user.stats.favorites}</span>
            <span className="profile-mobile-stat-label">Saved</span>
          </div>
          <div className="profile-mobile-stat">
            <span className="profile-mobile-stat-value">{user.stats.reviews}</span>
            <span className="profile-mobile-stat-label">Reviews</span>
          </div>
        </div>
{/* Switch to Customer */}
      <div className="wp-extra-cards">
        <div className="wp-extra-card wp-extra-card--switch" onClick={() => setSwitchModal(true)}>
          <div className="wp-extra-card__left">
            <div className="wp-extra-card__icon" style={{ background: 'rgba(139,92,246,0.12)', color: '#8b5cf6' }}>
              <RefreshCw size={18} />
            </div>
            <div className="wp-extra-card__info">
              <span className="wp-extra-card__label">Switch to Light Mode</span>
              <span className="wp-extra-card__sub"> Switch to Light Mode For clean and minimal interface.</span>
            </div>
          </div>
          <ChevronRight size={16} className="wp-extra-card__arrow" />
        </div>
      </div>
        {/* Mobile Menu List */}
        <div className="profile-mobile-menu">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="profile-mobile-item"
              onClick={() => handleMenuClick(item.route)}
            >
              <div className="profile-mobile-item-icon" style={{ backgroundColor: `${item.color}15` }}>
                <span style={{ color: item.color }}>
                  {item.icon}
                </span>
              </div>
              <span className="profile-mobile-item-title">{item.title}</span>
              <ChevronRight className="profile-mobile-item-arrow" />
            </div>
          ))}
          
          {/* Mobile Logout */}
        {/* Mobile Logout */}
<div
  className="profile-mobile-item profile-mobile-logout"
  onClick={handleLogout}
>
  <div
    className="profile-mobile-item-icon"
    style={{ backgroundColor: '#fee2e2' }}
  >
    <span style={{ color: '#ef4444' }}>
      <LogOut size={22} />
    </span>
  </div>

  <span className="profile-mobile-item-title">
    Log Out
  </span>

  <ChevronRight className="profile-mobile-item-arrow" />
</div>
          <div className="profile-menu-card profile-logout-card" onClick={handleDeleteProfile}>
  <div className="profile-menu-icon" style={{ backgroundColor: '#fee2e2' }}>
    <span style={{ color: '#ef4444' }}>
      <LogOut size={22} />
    </span>
  </div>

  <h5 className="profile-menu-title">Delete Account</h5>
  <p className="profile-menu-subtitle">Permanently remove your profile</p>

  <ChevronRight className="profile-menu-arrow" />
</div>
        </div>
      </div>

    </div>
    </>
  );
};

export default Profile;